import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
// import analytics from 'src/utils/analytics';

function AuthGuard({ children }) {
  const location = useLocation();
  const account = useSelector((state) => state.account);

  if (!account.user || account.user.firstLogIn !== 1) {
    const rawRedirect = new URLSearchParams(location.search).get("redirect");
    return <Redirect to={rawRedirect || "/app/solar-panels?terms=modules"} />
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
